/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/payment';
const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_ACTION = '/giftcard';
/**
 * add item to cart via facade
 * @param {*} wcEnv
 *
 */
const removeGiftCard = (wcEnv, jwtToken, orderId, account, giftCardId) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const resourcePage = `${RESOURCE_PAGE_FACADE}/${orderId}${RESOURCE_PAGE_ACTION}`;

    const payload = { account, giftCardId };

    return restClient.deleteFacade(env, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default removeGiftCard;
